module.exports = __webpack_public_path__ + "img/mona.2dbfb37c.svg";